import { ServiceToolCodeClient } from "api/api";
import { AsyncOperationBuilderWithoutState } from "utilities/api-helper";
import { serviceToolCodeClient } from "../api-clients";

export async function getServiceToolCode(unitId: string) {
	return await AsyncOperationBuilderWithoutState(
		apiClient => (apiClient as ServiceToolCodeClient).getServiceToolCode(unitId),
		serviceToolCodeClient,
	);
}